/* Beautiful Body · Home 2026
   Comportamiento de las secciones bb-*. Todo va por delegación de eventos,
   así sigue funcionando cuando el editor de temas vuelve a pintar una sección. */
(function () {
  if (window.__bbHome) return;
  window.__bbHome = true;

  function activateTab(tab) {
    var root = tab.closest('[data-bb-tabs]');
    if (!root) return;
    root.querySelectorAll('[data-bb-tab]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    root.querySelectorAll('[data-bb-panel]').forEach(function (p) {
      p.hidden = p.id !== tab.getAttribute('aria-controls');
    });
  }

  function closeDrawers() {
    document.querySelectorAll('details[data-bb-drawer][open]').forEach(function (d) {
      d.removeAttribute('open');
    });
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-bb-tab]');
    if (tab) { activateTab(tab); return; }

    if (e.target.closest('[data-bb-close]')) { e.preventDefault(); closeDrawers(); return; }
    if (e.target.closest('[data-bb-close-link]')) { closeDrawers(); return; }

    // cerrar submenús del menú de escritorio al hacer clic fuera
    document.querySelectorAll('.bb-nav details[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawers();
      document.querySelectorAll('.bb-nav details[open]').forEach(function (d) { d.removeAttribute('open'); });
    }
    var tab = e.target.closest && e.target.closest('[data-bb-tab]');
    if (tab && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
      var tabs = Array.prototype.slice.call(tab.closest('[data-bb-tabs]').querySelectorAll('[data-bb-tab]'));
      var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
      var next = tabs[(i + tabs.length) % tabs.length];
      next.focus();
      activateTab(next);
    }
  });

  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d.matches && d.matches('details[data-bb-drawer]')) {
      document.documentElement.style.overflow = d.open ? 'hidden' : '';
    }
  }, true);

  // sombra del encabezado al hacer scroll
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY > 40;
      document.querySelectorAll('.bb-header').forEach(function (h) { h.classList.toggle('is-scrolled', y); });
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  // ---------- búsqueda en la misma página ----------
  // Usa la búsqueda predictiva de Shopify (/search/suggest.json) y pinta los
  // resultados dentro del panel; nunca manda a la página de resultados.
  var search = { timer: 0, ctrl: null, cache: {}, opener: null };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(v) {
    var n = parseFloat(v);
    if (!n) return '';
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }

  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function highlight(text, q) {
    var safe = esc(text);
    var words = q.split(/\s+/).filter(function (w) { return w.length > 1; }).map(function (w) {
      return esc(w).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    });
    if (!words.length) return safe;
    return safe.replace(new RegExp('(' + words.join('|') + ')', 'gi'), '<mark>$1</mark>');
  }

  // Los modales de Expanse (p. ej. el popup de la lista de correo) atrapan el foco
  // aunque queden detrás de la búsqueda. El tema los cierra con el evento 'drawerOpen'.
  function closeThemeModals() {
    document.dispatchEvent(new CustomEvent('drawerOpen'));
  }

  function openSearch(btn) {
    var root = document.getElementById(btn.getAttribute('aria-controls')) || document.querySelector('[data-bb-search]');
    if (!root) return;
    closeDrawers();
    closeThemeModals();
    search.opener = btn;
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    btn.setAttribute('aria-expanded', 'true');
    // el foco va en el mismo toque para que el teclado del iPhone se abra
    var input = root.querySelector('[data-bb-search-input]');
    input.focus();
    if (input.value) input.select();
  }

  function closeSearch() {
    var root = document.querySelector('[data-bb-search]:not([hidden])');
    if (!root) return;
    root.hidden = true;
    document.documentElement.style.overflow = '';
    if (search.opener) {
      search.opener.setAttribute('aria-expanded', 'false');
      search.opener.focus();
    }
  }

  function renderResults(root, q, res) {
    var out = root.querySelector('[data-bb-search-results]');
    var idle = root.querySelector('[data-bb-search-idle]');
    var products = res.products || [];
    var collections = res.collections || [];
    var pages = res.pages || [];
    var queries = (res.queries || []).filter(function (s) { return s.text && s.text.toLowerCase() !== q.toLowerCase(); });
    var html = '';

    if (products.length) {
      html += '<div class="bb-search__group"><p class="bb-search__label">Tratamientos y productos</p><div class="bb-search__grid">';
      products.forEach(function (p) {
        var img = p.image || (p.featured_image && p.featured_image.url) || '';
        var price = money(p.price_min || p.price);
        if (price && p.price_max && p.price_min && parseFloat(p.price_max) > parseFloat(p.price_min)) price = 'Desde ' + price;
        html += '<a class="bb-search__item" href="' + esc(p.url) + '">' +
          '<span class="bb-search__thumb">' + (img ? '<img src="' + esc(sized(img, 360)) + '" alt="" loading="lazy" width="360" height="360">' : '') + '</span>' +
          '<span class="bb-search__meta"><span class="bb-search__name">' + highlight(p.title, q) + '</span>' +
          (price ? '<span class="bb-search__price">' + price + '</span>' : '') + '</span></a>';
      });
      html += '</div></div>';
    }

    var links = collections.concat(pages);
    if (links.length) {
      html += '<div class="bb-search__group"><p class="bb-search__label">Colecciones y páginas</p><div class="bb-search__chips">';
      links.forEach(function (l) { html += '<a class="bb-search__chip" href="' + esc(l.url) + '">' + esc(l.title) + '</a>'; });
      html += '</div></div>';
    }

    if (queries.length) {
      html += '<div class="bb-search__group"><p class="bb-search__label">Quizás buscabas</p><div class="bb-search__chips">';
      queries.slice(0, 5).forEach(function (s) {
        html += '<button type="button" class="bb-search__chip" data-bb-search-term="' + esc(s.text) + '">' + esc(s.text) + '</button>';
      });
      html += '</div></div>';
    }

    if (!products.length && !links.length) {
      var tpl = root.querySelector('template[data-bb-search-empty]');
      var box = document.createElement('div');
      box.appendChild(tpl.content.cloneNode(true));
      box.querySelector('[data-q]').textContent = '“' + q + '”';
      html = box.innerHTML + html;
    }

    idle.hidden = true;
    out.innerHTML = html;
  }

  function runSearch(root, raw) {
    var q = (raw || '').trim();
    var out = root.querySelector('[data-bb-search-results]');
    var idle = root.querySelector('[data-bb-search-idle]');
    clearTimeout(search.timer);
    if (search.ctrl) search.ctrl.abort();
    if (!q) {
      out.innerHTML = '';
      idle.hidden = false;
      root.classList.remove('is-loading');
      return;
    }
    if (search.cache[q]) { renderResults(root, q, search.cache[q]); return; }

    var url = root.getAttribute('data-url') + '.json?q=' + encodeURIComponent(q) +
      '&' + encodeURIComponent('resources[type]') + '=product,collection,page,query' +
      '&' + encodeURIComponent('resources[limit]') + '=8' +
      '&' + encodeURIComponent('resources[limit_scope]') + '=each' +
      '&' + encodeURIComponent('resources[options][unavailable_products]') + '=last';
    var ctrl = window.AbortController ? new AbortController() : null;
    search.ctrl = ctrl;
    root.classList.add('is-loading');
    fetch(url, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (d) {
        var res = (d.resources && d.resources.results) || {};
        search.cache[q] = res;
        var input = root.querySelector('[data-bb-search-input]');
        if (input.value.trim() === q) renderResults(root, q, res);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        renderResults(root, q, {});
      })
      .then(function () { if (search.ctrl === ctrl) root.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-bb-search-open]');
    if (opener) { e.preventDefault(); openSearch(opener); return; }
    if (e.target.closest('[data-bb-search-close]')) { e.preventDefault(); closeSearch(); return; }
    var term = e.target.closest('[data-bb-search-term]');
    if (term) {
      var root = term.closest('[data-bb-search]');
      var input = root.querySelector('[data-bb-search-input]');
      input.value = term.getAttribute('data-bb-search-term');
      input.focus();
      runSearch(root, input.value);
    }
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-bb-search-input]')) return;
    var root = e.target.closest('[data-bb-search]');
    var value = e.target.value;
    clearTimeout(search.timer);
    search.timer = setTimeout(function () { runSearch(root, value); }, 200);
  });

  document.addEventListener('submit', function (e) {
    if (!e.target.matches || !e.target.matches('[data-bb-search-form]')) return;
    e.preventDefault();
    var root = e.target.closest('[data-bb-search]');
    runSearch(root, root.querySelector('[data-bb-search-input]').value);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.querySelector('[data-bb-search]:not([hidden])')) closeSearch();
  });

  // Si el popup de la lista de correo se abre mientras alguien escribe, se cierra
  // sin marcarlo como visto (así sale en otra página) y el foco vuelve a la barra.
  // Se espera a que pase la trampa de foco que el tema activa 100 ms después de abrir.
  document.addEventListener('modalOpen', function () {
    if (!document.querySelector('[data-bb-search]:not([hidden])')) return;
    setTimeout(function () {
      var popup = document.querySelector('.modal--is-active[id^="NewsletterPopup-"]');
      closeThemeModals();
      if (popup) {
        try {
          localStorage.removeItem(popup.id.replace('NewsletterPopup-', 'newsletter-'));
          sessionStorage.removeItem('popupShownThisSession');
        } catch (err) {}
      }
      var input = document.querySelector('[data-bb-search]:not([hidden]) [data-bb-search-input]');
      if (input) input.focus();
    }, 160);
  });

  // editor de temas: al seleccionar un bloque de "objetivo", abrir su pestaña
  document.addEventListener('shopify:block:select', function (e) {
    var tab = document.querySelector('[data-bb-tab][data-block-id="' + e.detail.blockId + '"]');
    if (tab) activateTab(tab);
  });
})();
